import React from 'react';
import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from '@lingui/core';
import { BorderOutlined, SyncOutlined, CheckCircleOutlined, CloseCircleOutlined, EyeOutlined } from '@ant-design/icons';

export interface StatusConfig {
  label: MessageDescriptor;
  color: string;
  icon: React.ReactNode;
}

export const STATUS_CONFIG: Record<string, StatusConfig> = {
  open: { label: msg({ message: 'Open', context: 'Task status' }), color: '#1677ff', icon: <BorderOutlined aria-hidden="true" /> },
  in_progress: { label: msg`In Progress`, color: '#d46b08', icon: <SyncOutlined aria-hidden="true" /> },
  in_review: { label: msg`In Review`, color: '#722ed1', icon: <EyeOutlined aria-hidden="true" /> },
  done: { label: msg`Done`, color: '#389e0d', icon: <CheckCircleOutlined aria-hidden="true" /> },
  cancelled: { label: msg`Cancelled`, color: '#8c8c8c', icon: <CloseCircleOutlined aria-hidden="true" /> },
};

export const STATUS_COLUMNS = Object.entries(STATUS_CONFIG).map(([key, cfg]) => ({ key, ...cfg }));
